export default "__VITE_ASSET__CAVbWqt___"